import React from "react";
import { useTranslation } from "react-i18next";
import { optionClass } from "./optionClasses";

// value: boolean | undefined
const TrueFalse = ({ value, onChange, review, correct }) => {
  const { t } = useTranslation();
  const opts = [
    { key: true, label: t("quiz.true") },
    { key: false, label: t("quiz.false") },
  ];
  return (
    <div className="grid grid-cols-2 gap-3">
      {opts.map((o) => {
        const selected = value === o.key;
        return (
          <button
            key={String(o.key)}
            type="button"
            disabled={review}
            onClick={() => onChange(o.key)}
            className={optionClass({ selected, review, correct })}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
};

export default TrueFalse;
